import * as React from "react";

const Cad3D: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="24"
            viewBox="0 0 22 24"
        >
            <path 
                fill="#020202" 
                d="M11.37.17s-.07,0-.1,0l-.1.03L.68,4.71s-.01,0-.02,0c0,0-.01,0-.02,0-.01,0-.03.01-.04.02h0s-.01,0-.02.01c-.06.04-.11.1-.15.16,0,0,0,0,0,.01-.02.03-.03.07-.04.1-.01.04-.02.08-.02.13v14c0,.21.13.39.32.47l10.5,4s.01,0,.02,0c.03,0,.05.02.08.02.01,0,.02,0,.04,0,.01,0,.03,0,.04,0s.03,0,.04,0c.01,0,.02,0,.03,0,.03,0,.05-.01.08-.02.01,0,.02,0,.04-.01h0l10-4c.19-.08.31-.26.31-.46V5.17s0-.06,0-.09c0,0,0-.02,0-.03,0-.02-.01-.04-.02-.06,0,0,0-.01,0-.02-.01-.03-.02-.05-.04-.08,0,0,0-.01-.01-.02-.01-.02-.03-.03-.04-.05,0,0-.01-.01-.02-.02-.02-.02-.04-.04-.06-.05,0,0,0,0,0,0-.02-.01-.05-.03-.07-.04L11.58.21c-.07-.03-.13-.04-.2-.04h0ZM11.37,9.12L2.14,5.17,11.37,1.21l8.79,3.95-8.79,3.95h0ZM10.87,22.44l-9.5-3.62V5.92l8.39,3.6,1.11.48v12.44h0ZM11.87,22.43v-12.44l9-4.05v12.89l-9,3.6h0Z"
            />
            <text 
                fontSize="9.19" 
                fontFamily="TradeGothicLT-Bold, 'TradeGothic LT Bold'" 
                fontWeight="700" 
                transform="translate(1.82 16.47) rotate(19.43) scale(1.76 .95) skewX(10.12)"
            >
                <tspan x="0" y="0">3</tspan>
            </text>
            <text 
                fontSize="9.89" 
                fontFamily="TradeGothicLT-Bold, 'TradeGothic LT Bold'" 
                fontWeight="700" 
                transform="translate(12.3 19.32) rotate(-18.76) scale(1.46 .94) skewX(-13.13)"
            >
                <tspan x="0" y="0">D</tspan>
            </text>
        </svg>
    );
};

export default React.memo(Cad3D);
